import { render, staticRenderFns } from "./tzypscsc.vue?vue&type=template&id=3b19bc3e&scoped=true&"
import script from "./tzypscsc.vue?vue&type=script&lang=js&"
export * from "./tzypscsc.vue?vue&type=script&lang=js&"
import style0 from "./tzypscsc.vue?vue&type=style&index=0&id=3b19bc3e&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b19bc3e",
  null
  
)

export default component.exports